const common_en = {
  user_email: "Email",
  user_name: "User Name",
  password: "Password",
  login: "Login",
  logout: "Logout",
  change_password: "Change password",
  login_form_title: "ShutterB",
  invalid_login: "Invalid Credentials",
  //sidebar---------------------------
  shutterbs: "shutterbs",
  events: "Events",
  completed_events: "Completed Events",
  upcoming_events: "Upcoming Events",
  canceled_events: "Canceled Events",
  reports: "Reports",
  payments: "Payments",
  promo_codes: "Promo Codes",
  tax_and_fee: "Tax and Fee",
  smartphone_devices: "Smartphone devices",
  customers: "Customers",
  new_applicants: "New applicants",
  active_shutterbs: "Active shutterbs",
  archive: "Archive",
  hold: "Hold",
  home_page_shutterbs: "Home page shutterb",
  reels: "Recaps",
  reel_types: "Recap Types",
  reel_vibes: "Recap Vibes",
  recap_feedback: "Recap Feedback",
  invalid_sample_file_type: "Invalid Sample File Type",
  assign_reels: "Assign Recap",
  postal_codes: "Postal Codes",
  billing: "Billing",
  configurations: "Configurations",
  marketing: "Marketing",
  affiliate_links: "Affiliate Links",
  //shutterbs approval
  name: "Name:",
  email: "Email:",
  address: "Address:",
  smart_phone: "Smart phone:",
  instagram_handle: "Instagram Handle:",
  phone_number: "Phone Number:",
  distance: "Distance willing to travel:",
  approve: "Approve",
  deactivate: "Deactivate",
  activate: "Activate",
  date: "Date",
  id: "ID:",
  event_Id: "Event ID:",
  group_Id: "Group ID:",
  confirmation_email_sent: "Confirmation email sent",
  shutterb_diactivated: "shutterb Deactivated",
  shutterb_activated: "shutterb Activated",
  shutterb_approved: "shutterb Approved",
  set_hourly_rate: "Set Hourly Rate",
  hourly_rate: "Hourly Rate",
  hourly_rate_required: "Hourly rate  is required",
  hourly_rate_updated: "Hourly Rate Updated",
  resend_email: "Resend email",
  shutterb_rejected: "shutterb Rejected",
  reviews: "REVIEWS",
  average_rating: "RATING",
  reject: "Reject",
  sb_details_title: "SHUTTERB DETAILS",
  //events
  event_date: "Event Date:",
  event_host: "Event Host:",
  event_name: "Event Name",
  event_start_time: "Event Start time:",
  event_location: "Event Location:",
  appartment: "Appartment:",
  event_type: "Event Type:",
  additional_notes: "Additional Notes:",
  total_gallery_views: "Total Gallery Views:",
  sb_start_time: "shutterb Start Time:",
  duration: "Duration:",
  cancel_event: "Cancel Event",
  cancel_all_event: "Cancel All Event",
  contact_name: "On-Site Contact Name",
  contact_number: "On-Site Contact Phone Number",
  consent_for_marketing: "Consent for Marketing:",
  gallery_shared_permission: "shutterb can share gallery with guests: ",
  //payments
  view_details: "View Details",
  payment_successful: "Payment Successful",
  pay: "Pay",
  pending: "Pending",
  paid: "Paid",
  showing: "Showing",
  page: "Page",
  of: "of",
  show: "Show",
  amount: "Amount",
  account_status: "Account Status",
  shutterb_name: "shutterb",
  actions: "Actions",
  entries: "entries",
  something_went_wrong: "Something went wrong.",
  unable_to_access_server: "Unable to access server",
  undefined: "Something went wrong.",
  transferableAmount: "Transferable Amount",
  platformFee: "Platform Fee",
  sb_platform_fee: "Platform Fee For shutterb",
  reel_platform_fee: "Platform Fee For Reel",
  service_fee: "Service Fee",
  tax: "Tax",
  update: "Update",
  //forgot_password
  forgot_password: "Forgot password?",
  reset_password: "Reset Password",
  email_send: "Email Send",
  confirm_password: "Confirm Password",
  password_has_been_set_successfully: "Password has been set successfully",

  //PromoCodes
  code: "Code",
  description: "Description",
  value: "Value",
  type: "Type",
  start_date: "Start Date",
  end_date: "End Date",
  usage_per_customer: "Usage Per Customer",
  promocode_deactivated: "Promocode Deactivated",
  promocode_activated: "Promocode Activated",
  promo_code_already_exists: "Promo code already exists",
  promo_balance: "Promo Balance",
  discount: "Discount",
  balance: "Balance",
  promo_code_added_successfully: "Promo Code Added Successfully",
  number_of_users: "Number Of Users",
  gift_card: "Gift Card",
  number_of_redemptions: "Number Of Redemptions",
  gift_card_added_successfully: "Gift Card Added Successfully",

  //shutterb detail form
  first_name: "First Name",
  last_name: "Last Name",
  current_address: "Current Address",
  distance_willing_to_travel: "Distance Willing to Travel",
  email_address: "Email Address",
  instagram_handle_form: "Instagram Handle",
  phone_number_form: "Phone Number",
  current_smartphone: "Current Smartphone",
  shutterb_question_1: "Why do you want to work for shutterb?",
  shutterb_question_1_description:
    "Tell us why you’d fit into our community of go-getting, creative and talented individuals. We’re not only looking for good smartphone content creators, we are also looking for people who are personable, professional and passionate about doing what they love!",
  shutterb_question_2:
    "Why do you think you’ll be a great smartphone content creator?",
  shutterb_question_2_description:
    "Tell us what you like about smartphone content creation.  What’s your style and how do you approach it?  Do you have any smartphone accessories that enhance your capabilities as a smartphone content creator?",
  shutterb_question_3:
    "Have you ever worked independently as a gig worker / freelancer before?",
  shutterb_question_3_description:
    "What did you think about it? What were the benefits? What were the drawbacks?",
  shutterb_question_4:
    "How many hours do you plan to devote to shutterb a week?",
  shutterb_question_4_description:
    "When you’re a shutterb you need to commit to a minimum 1 x 3 hour window of availability per week, but we encourage you to make yourself as available as you can be!",
  hst_number: "HST Number",
  working_schedule: "Working Schedule",
  stripe_connected: "Stripe connected",

  //smartphone devices
  device_already_exists: "Device already exists",
  device_added_successfully: "Device added successfully",
  device_is_associated_with_shutterb: "Device is associated with shutterb.",
  device_remove_success: "Device Removed Successfully",
  devices_reordered_successfully: "Device Reordered Successfully",
  device_name: "Device Name",
  add: "Add",

  //customer
  customer_activated: "Customer Activated",
  customer_deactivated: "Customer Deactivated",
  //feature-shutterbs-to-homepage
  update_success: "Updated Successfully.",
  remove_from_website: "Removed Successfully",
  field_is_empty: "Field is empty",
  max_7_shutterbs_can_be_selected: "Cannot add more than 7 shutterbs",
  //reels
  assigned_successfully: "Assigned Successfully",
  rejected_events: "Rejected Events",
  referral_name: "Referral Name",
  shutterb_assigned_successfully: "shutterb assigned successfully",
  removed_successfully: "Removed Successfully",
  email_sent_failure: "Email sent Failure",
  //postal code
  already_exists: "Already exists",
  remove_successfully: "Removed successfully",
  postal_code_remove_success: "Postal Code Removed Successfully",
  delete_success: "shutterb removed successfully",
  //view Event Gallery
  view_gallery: "View Gallery",
  no_images:
    "Sorry the event content is not ready yet, please check back within 24 hours of the event ending.",
  no_deleted_files: "The deleted items gallery is empty",
  event_cancel_successfully: "Event cancel successfully",
  updated_successfully: "Updated successfully",
  file_successfully_deleted: "File successfully deleted",
  you_will_receive_an_email_when_its_ready:
    "You will receive an email when download is ready",
  download_files_email:
    "Your request is being processed.  Please allow for up to 10 minutes for this email to be sent to your inbox.",
  //modal buttons
  yes: "Yes",
  cancel: "Cancel",
  //Affiliate Marketing
  done_successfully: "Done Successfully",
  activate_successfully: "Activated Successfully",
  deactivate_successfully: "Deactivate Successfully",
  marketing_event_date: "Event Date",
  partner_name: "Partner Name",
  report: "Reports",
  total_shutterb_hours: "shutterb Hours",
  reel_count: "Reels",
  event_host_email: "Event Host Email",

  // Message Board
  see_messages: "See Messages",
  monitoring_report: "Monitoring Report",
  generate_event_report: "Generate Event Report",
  generate_customer_report: "Generate Customer Report",
  generate_shutterB_report: "Generate ShutterB Report",
  download_invoice: "Download Invoice",
  event_discarded_successfully: "event discarded successfully",
  price_must_be_positive_number: "Price must be positive number",
  reel_mode_configuration_not_found: "Reel Mode Configuration not found",
  action_type: "Action Type",
  time_requested: "Time Requested",
  file_name: "File Name",
  feedback: "Feedback",
  event_shot_list: "Event Shot List:",
  brand_and_legal_requirements: "Brand and Legal Requirements:",
  event_recap_details: "Event Recap Details",
  recap_detail: "Recap Detail",
  logo_url: "Logo Url",
  error_while_updating_configuration:
    "An error occurred while updating the configuration.",
  error_while_getting_configuration:
    "An error occurred while retrieving the configuration.",
  error_while_getting_events: "An error occurred while retrieving events.",
  error_while_creating_event: "An error occurred while creating event.",
  error_while_updating_event: "An error occurred while updating event.",
  error_while_getting_event_detail:
    "An error occurred while retrieving the event details.",
  error_while_caneling_event: "An error occurred while canceling the event.",
  error_while_getting_draft_events:
    "An error occurred while retrieving draft events.",
  error_while_getting_suggested_s_bz:
    "An error occurred while getting suggested SBz.",
  error_while_deleting_suggested_s_bz:
    "An error occurred while deleting suggested SBz.",
  error_while_informing_customer_about_suggested_s_bz:
    "An error occurred while informing customer about suggested SBz.",
  error_while_discarding_event: "An error occurred while discarding the event.",
  error_while_getting_event_detail_by_id:
    "An error occurred while retrieving the event details.",
  error_while_mapping_refund_dto_for_events:
    "An error occurred while mapping refund details for events.",
  error_while_retrieving_gift_cards:
    "An error occurred while retrieving gift card details.",
  error_while_adding_gift_card:
    "An error occurred while adding a new gift card.",
  error_while_toggling_gift_card_activation:
    "An error occurred while toggling the gift card activation.",
  error_while_creating_affiliate_marketing:
    "An error occurred while creating the affiliate marketing record.",
  error_while_retrieving_affiliate_marketing_records:
    "An error occurred while retrieving affiliate marketing records.",
  error_while_updating_affiliate_marketing:
    "An error occurred while updating the affiliate marketing record.",
  error_while_retrieving_affiliate_marketing_by_id:
    "An error occurred while retrieving the affiliate marketing record by ID.",
  error_while_toggling_affiliate_marketing_link_activation:
    "An error occurred while toggling the affiliate marketing link activation.",
  error_while_retrieving_affiliate_marketing_reports:
    "An error occurred while retrieving affiliate marketing reports.",
  error_while_retrieving_payment_details:
    "An error occurred while retrieving payment details.",
  error_while_adding_postal_codes:
    "An error occurred while adding postal codes.",
  error_while_retrieving_postal_codes:
    "An error occurred while retrieving postal codes.",
  error_while_deleting_postal_code:
    "An error occurred while deleting the postal code.",
  error_while_retrieving_promo_codes:
    "An error occurred while retrieving promo codes.",
  error_while_updating_promo_code:
    "An error occurred while updating the promo code.",
  error_while_retrieving_promo_code_by_id:
    "An error occurred while retrieving the promo code by ID.",
  error_while_retrieving_promo_code_by_code:
    "An error occurred while retrieving the promo code by code.",
  error_while_toggling_discount_activation:
    "An error occurred while toggling the discount code activation.",
  error_while_creating_promo_code:
    "An error occurred while creating the promo code.",
  error_while_updating_reels_item:
    "An error occurred while updating the reels item.",
  error_while_retrieving_reels_data:
    "An error occurred while retrieving reels data.",
  error_while_retrieving_event_reels:
    "An error occurred while retrieving event reels.",
  error_while_retrieving_shutter_b_for_reels:
    "An error occurred while retrieving ShutterB users for reels.",
  error_while_removing_reel_assignee:
    "An error occurred while removing the reel assignee.",
  error_while_retrieving_reel_brief:
    "An error occurred while retrieving the reel brief.",
  error_while_adding_reel_type: "An error occurred while adding the reel type.",
  error_while_retrieving_reel_template_by_id:
    "An error occurred while retrieving the reel template by ID.",
  error_while_retrieving_reel_templates:
    "An error occurred while retrieving reel templates.",
  error_while_updating_reel_mode_configurations:
    "An error occurred while updating reel mode configurations.",
  error_while_retrieving_reel_mode_configurations:
    "An error occurred while retrieving reel mode configurations.",
  error_while_deleting_reel_template:
    "An error occurred while deleting the reel template.",
  error_while_retrieving_all_reels_of_event:
    "An error occurred while retrieving all reels of the event.",
  error_while_retrieving_shutter_b_list:
    "An error occurred while retrieving the ShutterB list.",
  error_while_updating_shutter_b:
    "An error occurred while updating ShutterB details.",
  error_while_updating_shutter_b_status:
    "An error occurred while updating ShutterB status.",
  error_while_retrieving_shutter_b_by_id:
    "An error occurred while retrieving ShutterB details by ID.",
  error_while_setting_hourly_rate_of_shutter_b:
    "An error occurred while setting the hourly rate of ShutterB.",
  error_while_adding_device: "An error occurred while adding the device.",
  error_while_retrieving_devices: "An error occurred while retrieving devices.",
  error_while_removing_device: "An error occurred while removing the device.",
  error_while_adding_shutter_b_on_website:
    "An error occurred while updating ShutterB display status on the website.",
  error_while_displaying_shutter_b_on_website:
    "An error occurred while fetching ShutterB details for display on the website.",
  error_while_removing_shutter_b_from_website:
    "An error occurred while removing the ShutterB from the website.",
  error_while_fetching_shutter_b_for_event:
    "An error occurred while fetching ShutterB details for the specified event.",
  error_while_reassigning_shutter_b_for_event:
    "An error occurred while reassigning ShutterB for the event.",
  error_while_removing_shutter_b_from_event:
    "An error occurred while removing ShutterB from the event.",
  error_while_reordering_devices: "An error occurred while reordering devices.",
  error_while_fetching_users: "An error occurred while fetching users.",
  error_while_fetching_user_by_id:
    "An error occurred while fetching user details.",
  error_while_updating_user:
    "An error occurred while updating the user details.",
  error_while_deleting_user: "An error occurred while deleting the user.",
  error_while_fetching_event_types:
    "An error occurred while fetching the list of event types.",
  error_while_fetching_event_type_items:
    "An error occurred while fetching the list of event type items.",
  error_while_fetching_event_by_id:
    "An error occurred while fetching the event details.",
  error_while_fetching_event_detail_by_event_id:
    "An error occurred while fetching the event details by Event ID.",
  error_while_fetching_all_events:
    "An error occurred while fetching all events.",
  error_while_saving_event: "An error occurred while saving the event.",
  error_while_saving_draft_event:
    "An error occurred while saving the draft event.",
  error_while_referring_to_friend:
    "An error occurred while referring a friend.",
  error_while_uploading_music_file:
    "An error occurred while uploading the music file.",
  error_while_fetching_event_type_shot_list:
    "An error occurred while fetching the shot list for the event type.",
  error_while_getting_edit_brief:
    "An error occurred while getting the edit brief.",
  error_while_fetching_draft_events:
    "An error occurred while fetching draft events for the given event group.",
  error_while_fetching_events_by_group_id:
    "An error occurred while fetching events for the specified event group.",
  error_while_fetching_events_to_edit:
    "An error occurred while fetching events to edit.",
  error_while_fetching_available_shutterb:
    "An error occurred while fetching available ShutterB for the event.",
  error_while_assigning_shutterb:
    "An error occurred while assigning the ShutterB to the event.",
  error_while_notifying_admin_for_shutterb_assignment:
    "An error occurred while notifying the admin to assign the ShutterB.",
  error_while_creating_stripe_order_payment:
    "An error occurred while creating Stripe order payment for the order.",
  error_while_fetching_user_event_gallery:
    "An error occurred while fetching the user event gallery.",
  error_while_removing_event_gallery_image:
    "An error occurred while removing the image from the event gallery.",
  error_while_locking_gallery_files:
    "An error occurred while locking/unlocking the gallery files.",
  error_while_fetching_attended_events:
    "An error occurred while fetching the attended events.",
  error_while_fetching_recent_searches:
    "An error occurred while fetching the recent searches.",
  error_while_fetching_shared_gallery_files:
    "An error occurred while fetching the shared gallery files.",
  error_while_favoriting_event_gallery_clip:
    "An error occurred while updating the favorite status of the event gallery clip.",
  error_while_fetching_shared_gallery_files_for_event_group:
    "An error occurred while fetching the shared gallery files for the event group.",
  error_while_grouping_event_gallery_for_user:
    "An error occurred while grouping the event gallery for the user.",
  error_while_adding_or_updating_review:
    "An error occurred while adding or updating the review.",
  error_while_fetching_user_review:
    "An error occurred while fetching the user review.",
  error_while_fetching_reel_price:
    "An error occurred while fetching the reel price.",
  error_while_fetching_shutterb_by_event:
    "An error occurred while fetching shutterB details for the event.",
  error_while_sending_message: "An error occurred while sending the message.",
  error_while_sending_message_board_email:
    "An error occurred while sending the message board email.",
  error_while_fetching_message_board_messages:
    "An error occurred while fetching the message board messages.",
  error_while_fetching_shutter_b_by_id:
    "An error occurred while fetching the ShutterB details.",
  error_while_bulk_updating_message_status:
    "An error occurred while updating the message status.",
  error_while_updating_message_status:
    "An error occurred while updating the message status.",
  error_while_fetching_notifications:
    "An error occurred while fetching notifications.",
  error_while_fetching_notification_count:
    "An error occurred while fetching the notification count.",
  error_while_fetching_event_group_recap:
    "An error occurred while fetching the event group recaps.",
  error_while_fetching_user_events:
    "An error occurred while fetching the user events.",
  error_while_fetching_admin_event_groups:
    "An error occurred while fetching admin event groups.",
  error_while_adding_recap: "An error occurred while adding the recap.",
  error_while_fetching_shutter_b_by_location:
    "An error occurred while fetching ShutterB users by location.",
  error_while_fetching_sb_profile_schedule:
    "An error occurred while fetching the ShutterB profile schedule.",
  error_while_adding_or_updating_portfolio:
    "An error occurred while adding or updating the portfolio.",
  error_while_deleting_gallery_image:
    "An error occurred while deleting the gallery image.",
  error_while_fetching_sb_portfolio:
    "An error occurred while fetching the ShutterB portfolio.",
  error_while_fetching_sb_info:
    "An error occurred while fetching the ShutterB information.",
  error_while_updating_sb_info:
    "An error occurred while updating the ShutterB information.",
  error_while_adding_schedule: "An error occurred while adding the schedule.",
  error_while_adding_portfolio_images:
    "An error occurred while adding images to the portfolio.",
  error_while_viewing_sb_profile:
    "An error occurred while fetching the ShutterB profile.",
  error_while_updating_profile_schedule:
    "An error occurred while updating the profile schedule.",
  error_while_downloading_event_files:
    "An error occurred while preparing the event files for download.",
  error_while_fetching_sb_event_reels:
    "An error occurred while fetching the ShutterB event reels.",
  error_while_fetching_sb_events_list:
    "An error occurred while fetching the ShutterB events list.",
  error_while_fetching_sb_my_events_list:
    "An error occurred while fetching your ShutterB events list.",
  error_while_processing_sb_event_acceptance:
    "An error occurred while processing the ShutterB event acceptance.",
  error_while_updating_check_status:
    "An error occurred while updating the ShutterB check status.",
  error_while_fetching_sb_event_gallery:
    "An error occurred while fetching the ShutterB event gallery.",
  error_while_saving_sb_event_files:
    "An error occurred while saving ShutterB event files.",
  error_while_creating_s3_folder_structure:
    "An error occurred while creating the folder structure on S3.",
  error_while_adding_event_gallery_details:
    "An error occurred while adding event gallery details.",
  error_while_generating_invoice:
    "An error occurred while generating the invoice.",
  error_while_creating_checkout_session:
    "An error occurred while creating the checkout session.",
  error_while_processing_stripe_payment:
    "An error occurred while processing the Stripe payment.",
  error_while_sending_event_email:
    "An error occurred while sending the event email.",
  error_while_fetching_admin_details:
    "An error occurred while fetching admin details.",
  postal_code_added_successfully: "Postal Code Added Successfully.",
};

export default common_en;
